/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { create_sse_notification_tokenResponse } from '../types/create_sse_notification_token';

import type { UseResource } from '../../hooks/useResource';
import { useResource } from '../../hooks/useResource';

export type SseNotificationsTokenCreateRetrieveRequest = {} | null | undefined;
export type SseNotificationsTokenCreateRetrieveResponse = create_sse_notification_tokenResponse;

export type SseNotificationsTokenCreateRetrieveQuery = {};

/**
 * GET /dmx-server/sse_notifications_token/create/
 *
 * ```yaml
 * operationId: sse_notifications_token_create_retrieve
 * summary: Create sse notification token
 * tags:
 *   - sse_notifications_token
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/create_sse_notification_token'
 *     description: ''
 * ```
 */
export const sseNotificationsTokenCreateRetrieveOperation = (
  rest?: SseNotificationsTokenCreateRetrieveQuery | null,
) =>
  ({
    method: 'GET',
    path: `/dmx-server/sse_notifications_token/create/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'GET';
    path: string & { _templateUrl: '/dmx-server/sse_notifications_token/create/' };
  };

/**
 * GET /dmx-server/sse_notifications_token/create/
 *
 * ```yaml
 * operationId: sse_notifications_token_create_retrieve
 * summary: Create sse notification token
 * tags:
 *   - sse_notifications_token
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/create_sse_notification_token'
 *     description: ''
 * ```
 */
export const sseNotificationsTokenCreateRetrieve = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: SseNotificationsTokenCreateRetrieveQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<create_sse_notification_tokenResponse>> => {
  const operation = sseNotificationsTokenCreateRetrieveOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'GET',
    request,
    onUploadProgress,
    cancelToken,
  );
};

/**
 * GET /dmx-server/sse_notifications_token/create/
 */
export const useSseNotificationsTokenCreateRetrieveResource = (
  query: SseNotificationsTokenCreateRetrieveQuery | null,
  useCached?: boolean,
): UseResource<SseNotificationsTokenCreateRetrieveResponse> => {
  return useResource<SseNotificationsTokenCreateRetrieveResponse>({
    path: query === null ? null : sseNotificationsTokenCreateRetrieveOperation(query).path,
    apiUrl: globalThis.DMX_CONFIG.server,
    useCached,
  });
};
